import jwt from '../../http/requests/auth/jwt/index.js';

import 'firebase/auth';
import router from '@/router';

import axios from '@/axios';

export default {
  // JWT
  loginJWT(_context, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .login(payload.userDetails.email, payload.userDetails.password)
        .then(response => {
          // If there's user data in response
          if (response.data) {
            resolve(response);
          } else {
            reject({ message: response.data.msg });
          }
        })
        .catch(({ response }) => {
          reject({ message: response.data.msg });
        });
    });
  },
  registerUserJWT(_context, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .registerClinic(payload.userDetails)
        .then(response => {
          // Redirect User
          router.push(router.currentRoute.query.to || '/');
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  checkEmail(_context, email) {
    return new Promise((resolve, reject) => {
      jwt
        .checkEmailAvailability(email)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getInvitationDetail(_context, ref) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/admins/auth/getInvitationDetail', { params: { ref } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAllClinic() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/admins/fetchAllClinic')
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchClinics(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/admins/fetchUserList?page=' +
          data.page +
          '&limit=' +
          data.limit +
          '&search=' +
          encodeURIComponent(data.search || '') +
          '&sort=' +
          data.sort +
          '&dir=' +
          data.dir +
          '&userType=' +
          data.userType +
          '&activeClinicId=' +
          data.activeClinicId
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchDoctorClinics(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/admins/fetchUserListByType?page=' +
          data.page +
          '&limit=' +
          data.limit +
          '&search=' +
          encodeURIComponent(data.search || '') +
          '&sort=' +
          data.sort +
          '&dir=' +
          data.dir +
          '&userType=' +
          data.userType +
          '&activeClinicId=' +
          data.activeClinicId
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchSupplierClinics(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/admins/fetchSupplierClinicList?page=' +
          data.page +
          '&limit=' +
          data.limit +
          '&search=' +
          encodeURIComponent(data.search || '') +
          '&sort=' +
          data.sort +
          '&dir=' +
          data.dir +
          '&detailSupplierId=' +
          data.detailSupplierId +
          '&state=' +
          data.state
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  generateAdminClinicInvoice(_context, param) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/api/v1/admins/generateAdminClinicInvoice?clinic=${param.clinicId}&year=${param.year}&month=${param.monthNumber}`
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchAllClinics() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/userManagement/clinics/all')
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  fetchClinicsDetail(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/userManagement/clinics/' + id)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  updateClinicDetail(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          '/api/v1/clinics/userManagement/clinics/' + data.id + '/edit',
          data.data
        )
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  updateOpeningHours(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          '/api/v1/clinics/clinicOpeningHours/' + data.id,
          data.data
        )
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  resetClinicPassword(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          '/api/v1/clinics/userManagement/clinics/' +
          data.id +
          '/resetPassword',
          data.data
        )
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  createClinic(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/clinics/userManagement/clinics/create', data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  createClinicBasic(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/clinics/userManagement/clinics/create/basic', data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  deleteClinic(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete('/api/v1/clinics/userManagement/clinics/' + id + '/delete')
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getClinicDashboardData() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/dashboardData')
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  pairDevice(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/clinics/userManagement/clinics/pairDevice', data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err.data);
        });
    });
  },
  unPairDevice(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/clinics/userManagement/clinics/unPairDevice', data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err.data);
        });
    });
  },
  fetchPairDevice(_context, clinicId) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/userManagement/clinics/getPairedDevice', {
          params: clinicId,
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchAssociatedClinics(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/userManagement/clinics/getAssociatedClinics', {
          params: data,
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeAssociatedClinics(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          '/api/v1/clinics/userManagement/clinics/removeAssociatedClinics',
          data
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchToPairClinics(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/userManagement/clinics/fetchClinicToPair', {
          params: data,
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchAllTreatmentHistory(_context, params) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/clinics/getAllTreatmentHistories', params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchClinicAdmin(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/fetchClinicAdmin', { params: data })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createClinicAdmin(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/clinics/createClinicAdmin', data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicList(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/doctors/clinic/list', { params: data })
        .then((res) => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchClinicAdminDetail(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/fetchClinicAdminDetail/' + id)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateClinicAdmin(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          '/api/v1/clinics/updateClinicAdmin/' + data.clinicId,
          data.clinicData
        )
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  deleteSubClinic(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete('/api/v1/clinics/deleteClinicAdmin/' + id)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getStripePublishableKey() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/bankDetails/getPublishableKey')
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  createSetupIntent(_context, id) {
    return new Promise((resolve, reject) => {
      let path = '/api/v1/clinics/bankDetails/createSetupIntent';
      path = `/api/v1/clinics/bankDetails/createSetupIntent?clinicId=${id}`;
      axios
        .get(path)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  createPayToSetupIntent(_context, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/v1/clinics/payto/createSetupIntent?clinicId=${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  removePayTo(_context, { id, accountId }) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/v1/clinics/payto?clinicId=${id}&accountId=${accountId}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getMandateObject(_context, param) {
    return new Promise((resolve, reject) => {
      let path = `/api/v1/clinics/bankDetails/getMandateObject?intentId=${param.intentId
      }&accountHolderName=${param.accountHolderName
      }&accountHolderEmail=${encodeURIComponent(param.accountHolderEmail)}&clinicId=${param.clinicId}`;
      axios
        .get(path)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  submitStepDefaultPayment({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `/api/v1/clinics/default-payment-method/${payload.userId}/submit`,
          payload.body
        )
        .then(res => {
          localStorage.setItem(
            `${process.env.VUE_APP_ACCESS_TOKEN_NAME}FirstName`,
            res.data.data.firstName
          );

          localStorage.setItem(
            `${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`,
            JSON.stringify(res.data.data)
          );

          commit('UPDATE_USER_INFO', res.data.data, { root: true });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  saveClinicBankDetails({commit}, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/clinics/bankDetails/create', data)
        .then(res => {
          localStorage.setItem(
            `${process.env.VUE_APP_ACCESS_TOKEN_NAME}FirstName`,
            res.data.data.user.firstName
          );

          localStorage.setItem(
            `${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`,
            JSON.stringify(res.data.data.user)
          );

          commit('UPDATE_USER_INFO', res.data.data.user, { root: true });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateClinicBankDetails({commit}, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/clinics/bankDetails/edit', data)
        .then(res => {
          localStorage.setItem(
            `${process.env.VUE_APP_ACCESS_TOKEN_NAME}FirstName`,
            res.data.data.firstName
          );

          localStorage.setItem(
            `${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`,
            JSON.stringify(res.data.data)
          );

          commit('UPDATE_USER_INFO', res.data.data, { root: true });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getExistingDoctorRate() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/getExistingDoctorRate')
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  saveDoctorRate(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/clinics/saveDoctorRate', data)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  getClinicDoctorRate() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/getClinicDoctorRate')
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  uploadClinicImages(_context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          '/api/v1/clinics/uploadClinicImages?key=' + payload.key,
          payload.data,
          payload.config
        )
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  removeClinicImages(_context, imageUrl) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/removeClinicImages?imageUrl=' + imageUrl)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  resendVerificationEmail(_context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/onboardBusiness/resendEmail', payload)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  checkIfFranchiseClinic({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/checkIfFranchiseClinic')
        .then(res => {
          commit('IS_FRANCHISE_CLINIC', res.data.data);
          resolve(res);
        })
        .catch(err => reject(err));
    });
  },
  fetchTreatmentAreas(_context, dataTableParams) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/applicableAreas', { params: dataTableParams })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  changeTreatmentAreaStatus(_context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch('/api/v1/clinics/applicableAreas/changeStatus', payload)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  fetchDefaultConsentList() {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/admins/questionnaire-management?page=' +
          1 +
          '&limit=' +
          25 +
          '&search=&sort=createdAt&dir=asc'
        )
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchCustomConsentList(_context, clinicId) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/admins/custom-consent/' + clinicId)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  changeCustomConsentOrders(_context, data) {

    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/admins/custom-consent/' + data._id, data)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  transferAccount(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/admins/transferAccount', data)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  addNewPaymentMethod(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .addNewPaymentMethod(data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchClinicComplianceList(_context, data) {
    let path = '/api/v1/monthlyCompliance/' + data.clinicId + '/clinic/complianceList';
    return new Promise((resolve, reject) => {
      axios
        .get(path, {
          params: {
            page: data.page,
            limit: data.limit,
            sort: data.sort,
            search: data.search,
            year: data.year,
            month: data.month,
            clinic: data.clinic,
            status: data.status,
          },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchPOSEnabledClinics(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v1/clinics/get-pos-enabled-clinics/${data.orgId}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateScriptProductPatientDetails(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/v1/clinics/updateScriptProductPatientDetails/${data.id}`, data.payload)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  getClinicStripePaymentMethods(_context, data) {
    return axios.get(`/api/v1/clinics/stripe-payment-methods/${data.clinicId}`);
  },
};
